import { User } from 'contexts/ViewerContext'
import getConfig from 'next/config'
import snakeCase from 'utils/snakeCase'

export const getCioScript = () => {
  const { publicRuntimeConfig } = getConfig()
  const { CUSTOMERIO_SITE_ID } = publicRuntimeConfig

  return `
    var _cio = _cio || [];
    (function() {
      var a,b,c;a=function(f){return function(){_cio.push([f].
      concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
      "sidentify","track","page"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
      var t = document.createElement('script'),
          s = document.getElementsByTagName('script')[0];
      t.async = true;
      t.id    = 'cio-tracker';
      t.setAttribute('data-site-id', '${CUSTOMERIO_SITE_ID}');
      t.src = 'https://assets.customer.io/assets/track.js';
      //If your account is in the EU, use:
      //t.src = 'https://assets.customer.io/assets/track-eu.js'
      s.parentNode.insertBefore(t, s);
    })();`
}

export const identify = function (user: User): void {
  user &&
    (window as any)._cio.identify({
      id: user.cioFingerprint,
      email: user.email,
    })
}

export const track = function (name: string, data?: object): void {
  ;(window as any)._cio.track(snakeCase(name), data)
}
